import { useProductTranslations } from "../../hooks/TranslationHooks";
import { useLocSettings } from "../../hooks/SettingsHooks";
import classNames from "classnames";
import { currencyLocale } from "../../utils/MoneyUtils";

const FormattedPrice = function FormattedPrice({
  price: _price,
  price_unit,
  sales_unit,
  price_class_name,
  price_unit_class_name,
  bold_price = false,
  currency: _currency
}: {
  price: number | string;
  price_unit?: string;
  sales_unit?: string;
  price_class_name?: string;
  price_unit_class_name?: string;
  bold_price?: boolean;
  currency?: string;
}) {
  const tp = useProductTranslations();
  const settings = useLocSettings();
  const price = typeof _price === "string" ? parseFloat(_price) : _price;
  if (typeof price !== "number") {
    return <></>;
  }
  const currency = _currency || (settings.currency as string);
  const priceLocale = currencyLocale(currency);
  const priceComponent = (
    <span
      className={classNames({ "text-bold": !!bold_price }, price_class_name)}
    >
      {price
        .toLocaleString(priceLocale, {
          style: "currency",
          currency
        })
        .replace(/\D00\b/, "")}
    </span>
  );
  let priceUnitComponent = null;
  if (price_unit) {
    priceUnitComponent = " / " + tp("price_unit." + price_unit);
  }
  if (sales_unit) {
    priceUnitComponent = " / " + tp("sales_unit." + sales_unit);
  }
  if (price_unit_class_name && priceUnitComponent) {
    priceUnitComponent = (
      <span className={price_unit_class_name}>{priceUnitComponent}</span>
    );
  }
  return (
    <>
      {priceComponent}
      {priceUnitComponent}
    </>
  );
};

export default FormattedPrice;
